import { useState, useEffect, useRef } from 'react';
import { heroData, features } from '@/mocks/home';

export default function Hero() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <section ref={ref} className="relative w-full h-[600px] md:h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20coral%20and%20amber%20flowing%20gradient%20waves%20in%20a%20minimalist%20digital%20space%20with%20soft%20glowing%20light%20particles%2C%20clean%20white%20background%20with%20dynamic%20organic%20motion%20streaks%2C%20modern%20tech%20aesthetic%2C%20representing%20fast%20browsing%20speed%2C%20no%20blue%20or%20purple%20colors%2C%20warm%20golden%20and%20coral%20accents%2C%20artistic%20abstract%20visualization%2C%20high%20detail%20editorial%20quality&width=1800&height=900&seq=hero-bg-91browser&orientation=landscape"
          alt="91浏览器 - 极速安全的网页浏览体验"
          title="91浏览器 - 极速安全的网页浏览体验"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className={`transition-all duration-1000 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white mb-4 tracking-tight">
            {heroData.title}
          </h1>
          <p className="text-lg md:text-2xl text-white/80 font-heading font-semibold mb-6 tracking-wide">
            {heroData.subtitle}
          </p>
          <p className="text-sm md:text-lg text-white/60 max-w-2xl mx-auto mb-10 leading-relaxed">
            {heroData.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={heroData.primaryHref}
              className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white text-sm md:text-base font-semibold rounded-lg transition-all duration-200 transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
            >
              <i className="ri-download-line mr-2"></i>
              {heroData.primaryButton}
            </a>
            <a
              href={heroData.secondaryHref}
              className="px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white text-sm md:text-base font-semibold rounded-lg backdrop-blur-sm transition-all duration-200 border border-white/20 whitespace-nowrap cursor-pointer"
            >
              {heroData.secondaryButton}
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 rounded-full border-2 border-white/30 flex items-start justify-center pt-2">
          <div className="w-1.5 h-1.5 rounded-full bg-white/60"></div>
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id="features" className="w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            强大功能，重新定义浏览体验
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            91浏览器集成了多项领先技术，从底层引擎到上层交互，每一处细节都为您精心打磨
          </p>
        </div>

        <div className="space-y-20">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8 md:gap-14`}
            >
              <div className="flex-1 w-full">
                <div className="rounded-xl overflow-hidden bg-background-100">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    title={`91浏览器${feature.title}`}
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>
              <div className="flex-1">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
                  <i className={`${feature.icon} text-xl text-primary-600`}></i>
                </div>
                <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                  {feature.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}